module.exports = __webpack_public_path__ + "static/media/citynights.94cc27a5.jpg";